export default __webpack_public_path__ + "static/media/pantry1-afterF-1024w.e5ac5093.webp";